/**
 * lib/cvDefaults.js — RC 1.49.7 pre-Phase-5 hardening (2026-02)
 *
 * Single source of truth for the CV-generation default field set
 * shared between the wizard's <GenerateCvOptionsSheet> and the
 * route-based <CvSection>.
 *
 * Why a separate file?
 *   • Phase 6 wizard deletion (still operator-deferred) will delete
 *     `wizard/GenerateCvOptionsSheet.jsx`. Without this extraction
 *     the workspace's `import { DEFAULTS as GEN_CV_DEFAULTS } from
 *     '@/components/wizard/GenerateCvOptionsSheet'` would dangle.
 *   • Hoisting the constant here lets the wizard keep its own
 *     re-export for backwards-compat while the workspace cuts the
 *     build-time edge to the wizard surface. After Phase 6 the
 *     workspace stays compiling without code changes.
 *
 * Operator hard-rule: this file is a frozen constant. It is NOT
 * stateful, NOT a hook, and MUST NOT grow imports of any kind.
 * Any change to the defaults must clear with the wizard's
 * pre-flight UX modals (BaselineRefreshModal etc.) before
 * landing.
 */

// Default style on open. `standard` matches the historical
// baseline (standard_professional + analytical + flexible) — same
// triple the wizard has shipped since RC 1.41.G.
export const DEFAULT_STYLE = 'standard';

export const GEN_CV_DEFAULTS = Object.freeze({
  style:                 DEFAULT_STYLE,
  template_type:         'standard_professional',
  tone_type:             'analytical',
  length_preference:     'flexible',
  additional_cv_context: '',
});
